import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const OrdersModal = ({ isOpen, onClose, storeId, setIsFetched }) => {
  const activeStoreData = useSelector((state) => state.analysisData.activeStoreData);
  const navigate = useNavigate()

  const [formData, setFormData] = useState({
    start_date: '',
    end_date: '',
  });
  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: '',
    }));
  };
  
  const handleQuickSelect = (days) => {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - days + 1); // Include today

    const format = (date) => date.toISOString().split('T')[0];

    setFormData({
      start_date: format(start),
      end_date: format(end)
    })
    setErrors({})
  };
  const validate = () => {
    const newErrors = {};
    if (!formData.start_date) newErrors.start_date = 'Start date is required';
    if (!formData.end_date) newErrors.end_date = 'End date is required';
    if (formData.start_date && formData.end_date) {
      const start = new Date(formData.start_date);
      const end = new Date(formData.end_date);

      if (start >= end) {
        newErrors.start_date = "Start date must be earlier than end date";
        newErrors.end_date = "End date must be later than start date";
      }
    }
    return newErrors;
  };

  const handleSubmit = async () => {
    if(!activeStoreData.isActive){
      alert("Store is disconnected. Contact admin to enable order fetching.");
      return;
    }
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      setLoading(true)
      const response = await fetch(`${process.env.REACT_APP_FETCH_ORDERS}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`, // optional if needed
        },
        body: JSON.stringify({
          start_date: formData.start_date,
          end_date: formData.end_date,
          store_id: storeId,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        if (data.detail.isExpireToken) {
          const token = localStorage.removeItem("token");
          const user = localStorage.removeItem("userInfo");
          navigate("/login")
        }
        throw new Error(data.detail?.message || 'Failed to fetch orders');
      }

      // alert('Orders fetched successfully!');
      toast.success("Orders fetched successfully!", {
        position: "top-right",
        autoClose: 3000,
      });
      // getOrderDetails();
      onClose();
      setIsFetched(true)
    } catch (err) {
      // alert(`Error: ${err.message}`);
      toast.error(err.message, {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md mx-auto">
        <div className="px-6 py-5">
          <div className="flex items-center justify-between mb-6">
          <div>
          <h2 className="text-2xl font-bold text-gray-900">Fetch New Order Report</h2>
          <p className="mt-1 text-sm text-gray-500">Stay up to date by retrieving the latest orders from your connected Shopify store.</p>
          </div>
            <button onClick={()=> onClose()} className="text-gray-500 hover:text-gray-700 text-xl">
              <FaTimes />
            </button>
          </div>
{/* Quick Select Buttons */}
<div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">Quick Select</label>
            <div className="flex space-x-2">
              {[7, 30, 90].map((days) => (
                <button
                  key={days}
                  onClick={() => handleQuickSelect(days)}
                  className="px-3 py-1.5 text-sm bg-gray-100 rounded hover:bg-gray-200 transition"
                >
                  Last {days} Days
                </button>
              ))}
            </div>
          </div>
          {/* Date Range Inputs */}
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">Date Range</label>
            <div className="flex items-center space-x-2">
              <div className="flex-1">
                <input
                  type="date"
                  name="start_date"
                  value={formData.start_date}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                />
                {errors.start_date && <p className="text-xs text-red-600 mt-1">{errors.start_date}</p>}
              </div>
              <span className="text-gray-500">to</span>
              <div className="flex-1">
                <input
                  type="date"
                  name="end_date"
                  value={formData.end_date}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                />
                {errors.end_date && <p className="text-xs text-red-600 mt-1">{errors.end_date}</p>}
              </div>
            </div>
          </div>

          <hr/>

          {/* Action Buttons */}
          <div className="mt-4 flex justify-center space-x-3">
            <button
              onClick={() => onClose()}
              className="bg-gray-200 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-300 transition"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              disabled={loading}
              className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition"
            >
              {loading ? "Please wait..." : "Fetch Orders"}
            </button>
          </div>
        </div>
      </div>

    </div>


  );
};

export default OrdersModal;
